import axios from "axios";

const REQUEST_TIMEOUT_MS = 30000;

export const apiClient = axios.create({
  timeout: REQUEST_TIMEOUT_MS,
});

const FALLBACK_MESSAGE = "I'm having trouble processing your request. Please try again.";

export const getServerErrorMessage = (error, fallback = FALLBACK_MESSAGE) => {
  if (!error) return fallback;

  const responseData = error.response?.data;
  if (typeof responseData === "string" && responseData.trim()) {
    return responseData;
  }

  if (responseData && typeof responseData === "object") {
    const candidate =
      responseData.message ||
      responseData.error ||
      responseData.errorMessage ||
      responseData.details ||
      responseData.response;

    if (typeof candidate === "string" && candidate.trim()) {
      return candidate;
    }
  }

  if (error.code === "ECONNABORTED") {
    return "The request is taking longer than expected. Please try again in a moment.";
  }

  if (typeof error.message === "string" && error.message.trim()) {
    return error.message;
  }

  return fallback;
};
